import { IJBPMasterDealerExtendedPartnersView } from 'clickNgo/models/crud/views'
import { IEPRecord } from 'partner360/models/masterDealer'

export const mapEPRecordFromJBPMasterDealerExtendedPartnerView = (
  data: IJBPMasterDealerExtendedPartnersView
): IEPRecord => ({
  entryId: data.EntryId,
  epAcceptDate: data.EPAcceptDate,
  epDeclineDate: data.EPDeclineDate,
  epDeclineComment: data.epDeclineComment,
  epAddress: data.EPAddress,
  epAgreementExists: Boolean(data.EPAgreementExists),
  epAgreementStatus: data.EPAgreementStatus,
  epCity: data.EPCity,
  epCountry: data.EPCountry,
  epCountryCode: data.EPCountryCode,
  epCreatedBy: data.EPCreatedBy,
  epDnACluster: data.EPDnACluster,
  epEndDate: data.EPEndDate,
  epEPFlagExists: Boolean(data.EPEPFlagExists),
  epEPICodesAdded: Boolean(data.EPEPICodesAdded),
  epGeneralManagerCountryCode: data.EPGeneralManagerCountryCode,
  epGeneralManagerEmail: data.EPGeneralManagerEmail,
  epGeneralManagerLanguageCode: data.EPGeneralManagerLanguageCode,
  epGeneralManagerName: data.EPGeneralManagerName,
  epGeneralManagerPendingApproval: Boolean(data.EPGeneralManagerPendingApproval),
  epGeneralManagerPreferredLanguage: data.EPGeneralManagerPreferredLanguage,
  epGeoMarket: data.EPGeoMarket,
  epGeoRegion: data.EPGeoRegion,
  epHierarchyType: data.EPHierarchyType,
  epIsBusinessPartner: Boolean(data.EPIsBusinessPartner),
  epMarketL2: data.EPMarketL2,
  epMarketL3: data.EPMarketL3,
  epMarketL4: data.EPMarketL4,
  epMarketL5: data.EPMarketL5,
  epOffboarded: Boolean(data.EPOffboarded),
  epPartnerId: data.EPPartnerId,
  epPartnerName: data.EPPartnerName,
  epPartnerType: data.EPPartnerType,
  epServiceDelivery: data.EPServiceDelivery,
  epServiceDeliveryText: data.EPServiceDeliveryText,
  epStartDate: data.EPStartDate,
  epTandCAccepted: data.EPTandCAccepted,
  epTandCEmailSent: Boolean(data.EPTandCEmailSent),
  epTandCRecipient: data.EPTandCRecipient,
  epTandCRecipientName: data.EPTandCRecipientName,
  epTaxID: data.EPTaxID,
  epTCFlagExists: Boolean(data.EPTCFlagExists),
  epTopPartnerId: data.EPTopPartnerId,
  epZIPCode: data.EPZIPCode,
  epEmailEntryId: data.EPEmailEntryId,
  epEmailSentDate: data.EPEmailSentDate,
  epEmailCount: data.EPEmailCount,
  epEmailTo: data.EPEmailTo,
  epEmailToName: data.EPEmailToName,
  epStatus: data.EPStatus,
  epProgramType: data.EPProgramType,
  mdA3SQCertificationStatus: data.MDA3SQCertificationStatus,
  mdAgreementStatus: data.MDAgreementStatus,
  mdAmplifyStatus: data.MDAmplifyStatus,
  mdCMPSCertificationStatus: data.MDCMPSCertificationStatus,
  mdCountry: data.MDCountry,
  mdGeoMarket: data.MDGeoMarket,
  mdGeoRegion: data.MDGeoRegion,
  mdGMCountryCode: data.MDGMCountryCode,
  mdGMEmail: data.MDGMEmail,
  mdGMLanguageCode: data.MDGMLanguageCode,
  mdGMName: data.MDGMName,
  mdIsAgreementExist: Boolean(data.MDIsAgreementExist),
  mdIsMasterDealer: Boolean(data.MDIsMasterDealer),
  mdIsPowerServices: Boolean(data.MDIsPowerServices),
  mdMDPReporting: data.MDMDPReporting,
  mdPartnerId: data.MDPartnerId,
  mdPartnerName: data.MDPartnerName,
  mdPartnerType: data.MDPartnerType,
  mdStatus: data.MDStatus,
  mdThreshold: data.MDThreshold,
  pbmEmails: data?.PBMEmail ? data.PBMEmail.split(';') : [],
  epRiskStatus: data.EPRiskStatus,
})
